import AnkiImageOcclusion from '@/components/anki-image-occlusion/AnkiImageOcclusion';
import React from 'react';

export default function _AnkiImageOcclusion() {
  return <AnkiImageOcclusion />;
}
